import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ActivityProvider } from "@/context/ActivityContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/pages/AppShell";
import Dashboard from "@/pages/Dashboard";
import Akten from "@/pages/Akten";
import AkteDetail from "@/pages/AkteDetail";
import Mandanten from "@/pages/Mandanten";
import Fristen from "@/pages/Fristen";
import OWi from "@/pages/OWi";
import Settings from "@/pages/Settings";
import Eingang from "@/pages/Eingang";
import Aktionen from "@/pages/Aktionen";
import Versand from "@/pages/Versand";
import Verfahren from "@/pages/Verfahren";
import Abschluss from "@/pages/Abschluss";
import VollmachtSign from "@/pages/VollmachtSign";
import Portal from "@/pages/portal/Portal";
import Admin from "@/pages/Admin";
import Dokumente from "@/pages/Dokumente";
import Wiedervorlagen from "@/pages/Wiedervorlagen";
import "@/App.css";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ActivityProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/vollmacht/sign/:token" element={<VollmachtSign />} />
          <Route path="/portal/:token" element={<Portal />} />
          <Route path="/app" element={<RequireAuth><AppShell /></RequireAuth>}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="eingang" element={<Eingang />} />
            <Route path="akten" element={<Akten />} />
            <Route path="akten/:id" element={<AkteDetail />} />
            <Route path="mandanten" element={<Mandanten />} />
            <Route path="dokumente" element={<Dokumente />} />
            <Route path="wiedervorlagen" element={<Wiedervorlagen />} />
            <Route path="aktionen" element={<Aktionen />} />
            <Route path="versand" element={<Versand />} />
            <Route path="fristen" element={<Fristen />} />
            <Route path="verfahren" element={<Verfahren />} />
            <Route path="abschluss" element={<Abschluss />} />
            <Route path="owi" element={<OWi />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ActivityProvider>
    </AuthProvider>
  );
}

export default App;
